// Paket 75 (Geschenke): Hinweise zu aktivierten Geschenken.
//
// Server-Vertrag (server/gift-routes.js):
//   GET  /api/gifts/popups   → { gifts: [{ id, reason, tier, duration_days,
//                                activated_at, ends_at }] }
//   POST /api/gifts/:id/seen → { ok, changed }
// Aktiviert wird serverseitig beim ersten authentifizierten Kontakt; der
// Client zeigt nur noch den einmaligen Hinweis.
import { apiRequest } from './client';

export type GiftTier = 'plus' | 'ultra' | 'founders';

export interface GiftPopup {
  id: number;
  reason: string;
  tier: GiftTier;
  durationDays: number | null;
  activatedAt: string | null;
  endsAt: string | null;
}

function record(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : {};
}

function giftTier(value: unknown): GiftTier | null {
  return value === 'plus' || value === 'ultra' || value === 'founders' ? value : null;
}

export function normalizeGiftPopups(value: unknown): GiftPopup[] {
  const raw = record(value).gifts;
  if (!Array.isArray(raw)) return [];
  const out: GiftPopup[] = [];
  for (const entry of raw) {
    const row = record(entry);
    const id = Number(row.id);
    const tier = giftTier(row.tier);
    if (!Number.isSafeInteger(id) || id <= 0 || !tier || typeof row.reason !== 'string') continue;
    out.push({
      id,
      reason: row.reason,
      tier,
      durationDays: typeof row.duration_days === 'number' ? row.duration_days : null,
      activatedAt: typeof row.activated_at === 'string' ? row.activated_at : null,
      endsAt: typeof row.ends_at === 'string' ? row.ends_at : null,
    });
  }
  return out;
}

export async function getGiftPopups(): Promise<GiftPopup[]> {
  return normalizeGiftPopups(await apiRequest<unknown>('/api/gifts/popups'));
}

export function acknowledgeGiftPopup(giftId: number): Promise<unknown> {
  return apiRequest(`/api/gifts/${encodeURIComponent(String(giftId))}/seen`, { method: 'POST' });
}
